import React from 'react';
import { StyleSheet, Text, Pressable, View } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE } from '../../../constants/styles';
import { OPComponent } from '../../components';

export default class DidItButton extends OPComponent {
  constructor(props) {
    super(props);

    this._unMounted = true;

    // make sure its either null or a boolean
    const didIt = props.didIt == null ? null : props.didIt;

    this.state = {
      didIt,
      sendingDidIt: false,
    };
  }

  componentDidMount() {
    this._unMounted = false;
  }

  componentWillUnmount() {
    this._unMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.didIt !== this.props.didIt) {
      this.setState({ didIt: this.props.didIt });
    }
  }

  // after request to save did it val to server has completed
  saveDidItCompleted(didIt) {
    if (this._unMounted) return;
    this.setState({ didIt, sendingDidIt: false });
  }

  handlePress = () => {
    if (this.state.sendingDidIt) return;

    let prevDidIt = this.state.didIt;
    let newDidIt = !prevDidIt;
    this.setState({ didIt: newDidIt, sendingDidIt: true });

    this.props
      .saveDidIt(newDidIt)
      .then(() => {
        // make sure button is kept in sync, and tell it we're done
        // console.info('record did it success');
        this.saveDidItCompleted(newDidIt);
      })
      .catch((e) => {
        // console.info('record did it failed');
        this.saveDidItCompleted(prevDidIt);
      });
  };

  render() {
    let { didIt } = this.state;

    let didItButtonStyle;
    let didItButtonText;
    let didItButtonTextStyle;
    if (didIt === null) {
      didItButtonStyle = styles.done;
      didItButtonTextStyle = styles.doneText;
      didItButtonText = 'DONE?';
    } else {
      didItButtonStyle = didIt ? styles.didIt : styles.missedIt;
      didItButtonTextStyle = didIt ? styles.didItText : styles.missedItText;
      didItButtonText = didIt ? 'DID\nIT!' : 'MISSED\nIT!';
    }

    if (!this.props.visible) {
      return <View style={styles.didItButton} />;
    }

    return (
      <Pressable
        style={[styles.didItButton, didItButtonStyle]}
        onPress={this.handlePress}
        disabled={!this.props.editable || !!this.state.sendingDidIt}
      >
        <Text style={[styles.buttonText, didItButtonTextStyle]}>{didItButtonText}</Text>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  didItButton: {
    width: 80,
    height: 60,
    borderRadius: 15,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: __WEB__ ? 0 : 10,
    marginHorizontal: __WEB__ ? 5 : 0,
  },
  buttonText: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.small,
    textAlign: 'center',
  },
  done: {
    borderColor: 'rgb(151, 151, 151)',
    borderWidth: 2,
  },
  doneText: {
    color: COLOR.text,
  },
  didIt: {
    backgroundColor: '#35FFB9',
    borderColor: '#00C581',
    borderWidth: 2,
  },
  didItText: {
    color: COLOR.text,
  },
  missedIt: {
    backgroundColor: '#FEF2F2',
    borderColor: '#F05050',
    borderWidth: 2,
  },
  missedItText: {
    color: COLOR.text,
  },
});
